import React, { useEffect, useState } from 'react';
import './DaysModal.css';
import close from "../../../../../../../../assets/close.svg";

export default function DaysModal(props) {
  const [list, setList] = useState([]);
  useEffect(() => {
    setList(props.data || []);
    //eslint-disable-next-line
  }, []);

  return <>
    <div className="modal DaysModal">
      <div className="modal-header">
        <h2>Add Days Played</h2>
        <div className="sub-header">
          <div className="sub-header-left">
            <span>Select days of week</span>
          </div>
          <div className="sub-header-right">
            <span>Individual Registration</span>
          </div>
        </div>
        <span className="close" onClick={() => props.closeModal(null)}>
          <img src={close} alt='close-icon'/>
        </span>
      </div>
      <form>
        <div className="add-adminModal">
          {
            list.map((d, idx) => (
              <div className="parent-blk" key={idx}>
                <div className="parent-header">
                  <label className="checkbox">
                    {d.day}
                    <input type="checkbox" checked={d.checked} onChange={() => {
                      list[idx].checked = !list[idx].checked;
                      setList([...list]);
                    }} />
                    <span className="checkmark"></span>
                  </label>
                  <label className="checkbox" style={{
                    width: '40%',
                  }}>
                    <input type="checkbox" checked={d.indv_reg_allow} onChange={() => {
                      list[idx].indv_reg_allow = !list[idx].indv_reg_allow;
                      setList([...list]);
                    }} />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            ))
          }
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={() => props.closeModal(null)}>Cancel</button>
          <button type="submit" onClick={(e) => {
            e.preventDefault();
            props.closeModal({
              type: 'days_played', data: list.reduce((prev, curr) => {
                if (curr.checked) {
                  prev.push({
                    day: curr.day,
                    indv_reg_allow: curr.indv_reg_allow,
                  })
                  return prev;
                }
                return prev;
              }, [])
            });
          }}>Confirm</button>
        </div>
      </form>
    </div>
  </>
}